import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as sectionsActions from '../../redux/actions/sectionsActions';
import { bodyScroll } from '../../utils/utils';
import { userCanEdit } from '../../utils/permissionsOptions';

import AssessmentsList from '../features/dashboard/AssessmentsList';
import UploadAssessmentModal from '../features/dashboard/UploadAssessmentModal';

class AssessmentsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUploadAssessmentModal: false,
      selectedSection: null,
      selectedAssessments: [],
      showReminderText: false,
    };
  }

  componentDidMount() {
    const { status, dispatchSectionsActions, dispatchAssessmentsActions } = this.props;
    dispatchAssessmentsActions.getAssessments();
    if (!status.sections) dispatchSectionsActions.getSections();
  }

  toggleUploadAssessmentModal = () => {
    bodyScroll.toggle();
    this.setState(prevState => ({ showUploadAssessmentModal: !prevState.showUploadAssessmentModal }));
  }

  toggleAssessment = (assessmentId, section) => {
    const { selectedSection, selectedAssessments } = this.state;
    if ((selectedSection === null || selectedSection === section) && (selectedAssessments.length <= 2 || selectedAssessments.indexOf(assessmentId !== -1))) {
      const index = selectedAssessments.indexOf(assessmentId);
      if (index === -1) {
        // Add it
        this.setState(prevState => ({
          selectedAssessments: [
            ...prevState.selectedAssessments,
            assessmentId,
          ],
        }));
      } else {
        // Remove it
        const newArr = [...selectedAssessments];
        newArr.splice(index, 1);
        this.setState({ selectedAssessments: newArr });
      }
      this.updateSelectedSection(section);
    }
  }

  updateSelectedSection = (section) => {
    this.setState(prevState => ({
      selectedSection: prevState.selectedAssessments.length
        ? section
        : null,
    }));
  }

  onCompareClick = () => {
    const { selectedAssessments } = this.state;
    const { history } = this.props;
    this.setState({ showReminderText: false });
    if (selectedAssessments.length > 0) {
      const compareUrl = '/review?assessments[]=' + selectedAssessments.join('&assessments[]=');
      history.push(compareUrl);
    } else {
      this.setState({ showReminderText: true });
    }
  }

  render() {
    const { selectedAssessments, showReminderText, selectedSection, showUploadAssessmentModal } = this.state;
    const { user, dispatchAssessmentsActions, history } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>Assessments</title>
        </Helmet>
        <div className="page-header">
          <div className="row">
            <h1 className="page-header__heading">Assessments</h1>
          </div>
        </div>
        <div className="dashboard-content row">
          <div className="dashboard-content__explanation">
            <h2 className="dashboard-content__subhead">
              Compare Assessments
            </h2>
            <p className="dashboard-content__description">
              Assessment modules of the same type (up to three assessments) can be selected to generate a side-by-side comparison.
            </p>
            <button
              type="button"
              onClick={this.onCompareClick}
              className={`button button--large dashboard-content__compare-button button--brand button--compare ${selectedAssessments.length === 0 ? 'disabled' : ''}`}
            >
              Compare Assessments
            </button>
            {showReminderText && (
              <p className="dashboard-content__reminder-text">
                Please select one or more completed assessments below.
              </p>
            )}
          </div>
          <div className="dashboard-content__sidebar">
            {userCanEdit(user) && (
              <Fragment>
                <Link to="/assessments/new" className="button button--full-width button--large dashboard-content__button dashboard-content__button--no-text">
                  Start New Assessment
                </Link>
                <button
                  type="button"
                  onClick={this.toggleUploadAssessmentModal}
                  className="button button--full-width button--large dashboard-content__button"
                >
                  Upload Assessment
                </button>
                <p className="dashboard-content__text">
                  Upload a PDF of your scanned paper assessment to the database
                </p>
              </Fragment>
            )}
          </div>
          <AssessmentsList
            assessmentsActions={dispatchAssessmentsActions}
            selectedAssessments={selectedAssessments}
            toggleAssessment={this.toggleAssessment}
            selectedSection={selectedSection}
            history={history}
          />
        </div>
        <UploadAssessmentModal
          visible={showUploadAssessmentModal}
          toggleUploadAssessmentModal={this.toggleUploadAssessmentModal}
          assessmentsActions={dispatchAssessmentsActions}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    status: state.status,
    user: state.users.roster[state.users.currentUserId],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchAssessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    dispatchSectionsActions: bindActionCreators(sectionsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssessmentsPage);



// WEBPACK FOOTER //
// ./src/components/pages/AssessmentsPage.js